import { sectionForMenuId, type SidebarSection } from './sidebarSections';
import type { Menu } from './types';

/**
 * Secciones que no agrupan: sus entradas se pintan al mismo nivel que el resto
 * del menú. En sporttia-competitions "Ligas" y "Torneos" cuelgan directamente de
 * COMPETICIONES, sin cabecera plegable.
 */
const FLAT_SECTIONS: SidebarSection[] = ['competitions'];

/**
 * Sube los submenús de las secciones que no agrupan a entradas de primer nivel.
 * El `id` pasa a ser el path del submenú (es único en menus.json) para que sirva
 * de ancla del tour y de icono.
 */
export function promoteFlatSectionMenus(menus: Menu[]): Menu[] {
    return menus.flatMap((menu) => {
        const isFlatSection = FLAT_SECTIONS.includes(sectionForMenuId(menu.id));

        if (!isFlatSection || !menu.submenus || menu.submenus.length === 0) {
            return [menu];
        }

        return menu.submenus.map((submenu) => ({
            id: submenu.path ?? `${menu.id}-${submenu.caption}`,
            caption: submenu.caption,
            path: submenu.path,
            url: submenu.url,
            params: submenu.params,
            privilege: submenu.privilege,
            permission: submenu.permission,
            module: submenu.module,
            external: submenu.external,
            beta: submenu.beta,
        }));
    });
}
